export function setDocumentStyles(styles: Partial<CSSStyleDeclaration>): Partial<CSSStyleDeclaration> {
  const documentStyle = document.documentElement.style
  const originalStyles: Partial<CSSStyleDeclaration> = {}

  for (const key in styles) {
    if (documentStyle[key] !== styles[key]) {
      originalStyles[key] = documentStyle[key]
      documentStyle[key] = styles[key]
    }
  }

  return originalStyles
}
